import React from "react";
import { useSelector } from "react-redux";

import { Title, CartIcon, LoginIcon } from "../../components";
import { Logo } from "./components/Logo/Logo";
import { MobileMenuButton } from "./components/MobileMenuButton/MobileMenuButton";
import { ReturnButton } from "./components/ReturnButton/ReturnButton";
import { MainMenuList } from "./components/MainMenuList/MainMenuList";

import { setAuth } from "../../redux/profile/authAndReg/slice";
import { accessTokenSelector } from "../../redux/auth/selectors";
import { useAppDispatch } from "../../redux/store";
import { useCurrentWidth } from "../../hooks";
import { MediaBreakPoints } from "../../resources/constants";
import { useMobileMenu } from "./hooks/useMobileMenu";

import styles from "./header.module.scss";
import { MainMenuItemsType, HeaderPropsType } from "./types";

const mainMenuItems: MainMenuItemsType = [
  { id: "subscriptions", name: "Абонементы", href: "/subscriptions", subMenu: false },
  { id: "rentHalls", name: "Аренда залов", href: "/halls", subMenu: false },
  { id: "about", name: "О клубе", href: "#", subMenu: "SubMenuAbout" },
  { id: "contacts", name: "Контакты", href: "/contacts", subMenu: false },
];

export const Header: React.FC<HeaderPropsType> = (props) => {
  const { title, returnButton = false } = props;
  const accessToken = useSelector(accessTokenSelector);
  const dispatch = useAppDispatch();
  const windowWidth = useCurrentWidth();
  const breakPoint = MediaBreakPoints.MOBILE_LARGE;
  const isMobile = windowWidth < breakPoint;

  const { isOpen, open, close, menuRef, buttonRef } = useMobileMenu();

  React.useEffect(() => {
    dispatch(setAuth(accessToken));
  }, [accessToken, dispatch]);

  return (
    <header className={`${styles.wrapper} container`}>
      <Logo />

      {returnButton && <ReturnButton />}

      <Title newStyles={styles.title} mountLocation="header">
        {title}
      </Title>

      <MainMenuList
        menuItems={mainMenuItems}
        isMobile={isMobile}
        onItemClick={close}
        isMenuOpen={isOpen}
        onClose={close}
        menuRef={menuRef}
      />

      <div className={styles.icons}>
        <CartIcon />
        <LoginIcon />
        {!returnButton && (
          <MobileMenuButton 
            onClick={open} 
            buttonRef={buttonRef}
            className={isOpen ? styles.menuButtonHidden : ''}
          />
        )}
      </div>
    </header>
  );
};
